import React, { useEffect } from 'react';
import { LayoutComposer } from '../../components';
import TopbarContainer from '../../containers/TopbarContainer/TopbarContainer';
import FooterContainer from '../../containers/FooterContainer/FooterContainer';
import { NamedLink } from '../../components';
import Map from '../../components/Map/Map';
import css from './LandingPage.module.css';
import CommonCards from './Components/InfoSection/CommanCards';
import Farmers from './Components/FarmersSection/Farmar';
import GainByJoining from './Components/GainByJoining/GainByJoining';
import Steps from './Components/Steps/Steps';
import Contributors from './Components/Contributors/Contributors';
import FaqSection from './Components/FaqSection/FaqSection';
import Navbar from './Components/Navbar/Navbar';

const LandingPage = props => {
  // Preload background image for faster loading
  useEffect(() => {
    const img = new Image();
    img.src = '/static/assets/PORTADA.jpg';
    img.loading = 'eager'; // Prioritize loading
  }, []);

  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <LayoutComposer areas={layoutAreas} className={css.root}>
      {layoutProps => {
        const { Topbar, Main, Footer } = layoutProps;
        return (
          <>
         
            <Topbar as="header" className={`${css.topbar} custom-header`}>
               <Navbar />   
              {/* <TopbarContainer currentPage="LandingPage" /> */}
            </Topbar>
           
            <Main as="main" className={css.main}>
              {/* SECTION: Hero */}
              <section className={css.hero}>
                <h1 className={css.heroTitle}>BioCerca</h1>
                <p className={css.heroSubtitle}>
                  Cambiará tu forma de conectar con quienes cultivan lo que comes.
                </p>
                <NamedLink name="SignupPage" className={css.heroButton}>
                  ÚNETE A LA REVOLUCIÓN
                </NamedLink>
              </section>

              {/* SECTION: What is BioCerca */}
              <CommonCards/>
              {/* <Farmers/> */}
              
                  <section className={`${css.section} ${css.stepsSection}`}>
                <h2 className={css.sectionTitle}>¿Cómo funciona?</h2>
                <p className={css.sectionSubtitle}>
                  Comer sano no debería parecer un lujo. “Volver a lo real nunca fue tan fácil”
                </p>

                {/* Interactive Map */}
                <div className={css.mapContainer}>
                  <div className={css.mapWrapper}>
                  <NamedLink
                    name="SearchPage"
                    className={css.mapLink}
                    to={{ search:"address=Espa%C3%B1a&bounds=28.08136788%2C-15.4942265%2C27.93951364%2C-15.62583784&mapSearch=true" }}
                    >
                    <Map
                      center={{ lat: 28.0166666, lng:-15.5166646 }}
                      zoom={6}
                      useStaticMap={false}
                      className={css.landingMap}
                      mapRootClassName={css.landingMapRoot}
                    />
                 </NamedLink>
                  </div>
                </div>
               
              </section>
              {/* <section className={`${css.section} ${css.featuresSection}`}>
               
              

                <div className={css.feesTableContainer}>
                  <p className={css.feesNote}>* Detalle de cuotas:</p>
                  <table className={css.feesTable}>
                    <thead>
                      <tr>
                        <th>Mes</th>
                        <th>Cuota mensual</th>
                        <th>Comentario</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>1-3</td>
                        <td>0€</td>
                        <td>Periodo de prueba gratuito, sin compromiso</td>
                      </tr>
                      <tr>
                        <td>4-6</td>
                        <td>19€/mes</td>
                        <td>Entrada suave, empiezan a ver resultados</td>
                      </tr>
                      <tr>
                        <td>7-9</td>
                        <td>29€/mes</td>
                        <td>Ya conocen el funcionamiento, es sostenible</td>
                      </tr>
                      <tr>
                        <td>10-12</td>
                        <td>39€/mes</td>
                        <td>Ajuste gradual hacia la cuota final</td>
                      </tr>
                      <tr>
                        <td>A partir del 13</td>
                        <td>49€/mes</td>
                        <td>Cuota definitiva, con opción de incluir mejoras Premium</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div style={{ textAlign: 'center', marginTop: '48px' }}>
                  <NamedLink name="SignupPage" className={css.infoButton}>
                    Empieza GRATIS ahora
                  </NamedLink>
                </div>
              </section> */}
              <Steps/>
          <GainByJoining mainCss={css}/>
            
              {/* SECTION: Recipes */}
              <section className={`${css.section} ${css.recipesSection}`}>
                <h2 className={css.sectionTitle}>RECETAS: Y luego… a cocinar</h2>
                <div className={css.infoBody}>
                  <p>
                    Sabemos lo que estás pensando: "¿Y ahora qué hago con estas acelgas que tienen
                    nombre y apellido?"
                  </p>
                  <p>
                    No te preocupes. En nuestra sección de recetas encontrarás inspiración real,
                    fácil y sabrosa para sacarle todo el jugo a lo que elegiste.
                  </p>
                  <p>Porque cocinar también es un acto de amor… y aquí empieza desde la tierra.</p>
                </div>
                {/* Link to RecipesPage */}
                <div style={{ textAlign: 'center' }}>
                  <NamedLink
                    name="RecipesPage"
                    className={css.infoButton}
                    style={{ backgroundColor: 'white', color: 'var(--colorBioCercaGreen)' }}
                  >
                    Ver Recetas
                  </NamedLink>
                </div>
              </section>
              <Contributors/>            
              <FaqSection/>
              
            </Main>
            <Footer>
              <FooterContainer />
            </Footer>
          </>
        );
      }}
    </LayoutComposer>
  );
};

export default LandingPage;
